(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onweb-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-onweb-tab]');
    if (tab) {
      var box = tab.closest('.onweb-svc');
      box.querySelectorAll('[data-onweb-tab]').forEach(function (t) {
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      box.querySelectorAll('[data-onweb-panel]').forEach(function (p) {
        p.hidden = p.dataset.onwebPanel !== tab.dataset.onwebTab;
      });
      return;
    }
    var sw = e.target.closest('.onweb-switch');
    if (sw) {
      var on = sw.getAttribute('aria-pressed') !== 'true';
      sw.setAttribute('aria-pressed', on ? 'true' : 'false');
      sw.closest('.onweb-hero').classList.toggle('is-off', !on);
    }
  });
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-onweb-rot]').forEach(function (rot) {
      var items = rot.children;
      var i = 0;
      if (items.length < 2) return;
      setInterval(function () {
        items[i].className = 'is-out';
        i = (i + 1) % items.length;
        items[i].className = 'is-on';
      }, 2200);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
